import {
  AgentInfoRentRelatedComponent,
  ContactInfoRentRelatedComponent,
  DetailsRentRelatedComponent,
  InvoiceRentRelatedComponent,
  SummaryRentRelatedComponent,
} from '../Sections';

export const UnitsRentRelatedSteps = [
  { label: 'agent-info', component: AgentInfoRentRelatedComponent },
  { label: 'contact-info', component: ContactInfoRentRelatedComponent },
  { label: 'details', component: DetailsRentRelatedComponent },
  { label: 'invoice-description', component: InvoiceRentRelatedComponent },
  { label: 'summary', component: SummaryRentRelatedComponent },
];
